module.exports = "https://www.gc-pro.gnp.com.mx/eef7ed5661b8d9386267d8e10791469a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_gastos_off.svg
// module id = 694
// module chunks = 0